var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLcLoginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_720_822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2941 14.9343C18.2941 15.6632 17.7008 16.2685 16.9592 16.2685H1.34734C0.605684 16.2685 0 15.6632 0 14.9343C0 14.2054 0.605684 13.5876 1.34734 13.5876H16.9468C17.6885 13.5876 18.2818 14.193 18.2818 14.9343H18.2941Z",
    fill: "#243D63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3695 24.2122C19.8887 24.7311 19.8887 25.5836 19.3695 26.1148L19.0852 26.399C18.566 26.9179 17.6513 26.9796 17.1445 26.4607C16.885 26.2013 16.749 25.8677 16.749 25.5218C16.749 25.1759 16.885 24.83 17.1445 24.5705L17.4906 24.2246C18.0098 23.7057 18.8627 23.7057 19.3819 24.2246L19.3695 24.2122Z",
    fill: "#243D63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 14.9343C30.0001 15.2802 29.8641 15.6261 29.6169 15.8732L23.1645 22.3221C22.6453 22.841 21.7924 22.841 21.2609 22.3221C20.7418 21.8032 20.7418 20.9508 21.2609 20.4196L26.7615 14.9219L17.1324 5.28555C16.8728 5.03847 16.7368 4.70489 16.7368 4.34661C16.7368 3.98834 16.8728 3.65479 17.1324 3.39535C17.3796 3.14826 17.7133 3 18.0718 3C18.4303 3 18.764 3.14826 19.0236 3.39535L29.6169 13.983C29.8641 14.2301 30.0001 14.576 30.0001 14.9343Z",
    fill: "#243D63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_720_822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLcLoginIcon);
export default __webpack_public_path__ + "static/media/LCLoginIcon.68f721644ef43383a97f419d7e6c5841.svg";
export { ForwardRef as ReactComponent };